<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="省份名称" prop="provinceName" >
        <a-input v-model="form.provinceName" placeholder="请输入省份名称" />
      </a-form-model-item>
      <a-form-model-item label="免费申领时收取的邮费" prop="freeClaimPostage" >
        <a-input-number v-model="form.freeClaimPostage" :min="0" :step="1" :precision="0" placeholder="请输入免费申领时收取的邮费" />
      </a-form-model-item>
      <a-form-model-item label="非免费申领时收取的邮费" prop="nonFreeClaimPostage" >
        <a-input-number v-model="form.nonFreeClaimPostage" :min="0" :step="1" :precision="0" placeholder="请输入非免费申领时收取的邮费" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getRemoteProvincePriceConfig, addRemoteProvincePriceConfig, updateRemoteProvincePriceConfig } from '@/api/played/remoteProvincePriceConfig'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        provinceName: null,
        freeClaimPostage: null,
        nonFreeClaimPostage: null,
        extraCopyPostage: null,
        creator: null,
        createTime: null,
        modifier: null,
        updateTime: null,
        isDeleted: null,
        remark: null,
        version: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        provinceName: [
          { required: true, message: '省份名称不能为空', trigger: ['blur', 'change'] }
        ],
        freeClaimPostage: [
          { required: true, message: '免费申领时收取的邮费不能为空', trigger: ['blur', 'change'] }
        ],
        nonFreeClaimPostage: [
          { required: true, message: '非免费申领时收取的邮费不能为空', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        provinceName: null,
        freeClaimPostage: null,
        nonFreeClaimPostage: null,
        creator: null,
        createTime: null,
        modifier: null,
        updateTime: null,
        isDeleted: null,
        remark: null,
        version: null
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getRemoteProvincePriceConfig(id).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateRemoteProvincePriceConfig(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addRemoteProvincePriceConfig(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
